import {
  CircularProgress,
  Collapse,
   Table, TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/styles";
import {Add, ExpandLess, ExpandMore, Remove} from "@material-ui/icons";
import Divider from "@material-ui/core/Divider";
import CompanyBranchesRow from "../acordionRows/CompanyBranchesRow";
import CurrentlyEmployedRow from "../acordionRows/CurrentlyEmployedRow";
import axios from 'axios';
import CustomSnackbar from "../../../user/shared/CustomSnackbar";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  addNewRelationshipLink: {
    textTransform: 'capitalize',
    textDecoration: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'none',
    }
  },
}));
const CompanyInfo = (props) => {
  const classes = useStyles();
  const[currentlyEmployedAccordion,setCurrentlyEmployedAccordion] = useState(false);
  const[companyBranchesAccordion,setCompanyBranchesAccordion] = useState(false);

  const [companyBranches, setCompanyBranches] = useState([]);
  const [currentCompanies, setCurrentCompanies] = useState([]);
  const [statusBranches, setStatusBranches] = useState('fetching');
  const [statusCurrentCompanies, setStatusCurrentCompanies] = useState('fetching');
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const {
    contactId,
    handleTabChange,
    tab,
    tabNumber,
    itemType,
    adminUserSession,
  } = props;

  useEffect(() => {
    axios.get(
      `/v1/admin/ria_contacts/${contactId}/company_branches`,
      {
        params: { entity_type: itemType },
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { company_branches, status } = response.data;

      setStatusBranches(status);
      setCompanyBranches(company_branches);
    });
  }, []);

  useEffect(() => {
    axios.get(
      `/v1/admin/ria_contacts/${contactId}/ria_current_company`,
      {
        params: { entity_type: itemType },
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { ria_current_company, status } = response.data;

      setStatusCurrentCompanies(status);
      setCurrentCompanies(ria_current_company);
    });
  }, []);

  const handleOnChangePrimaryLocation = (company_branch, value) => {
    setCompanyBranches(companyBranches.map((branch) => branch.id === company_branch.id ?
        {...branch, changed: true, currently_employed_company_primary_location: value === 'Yes', currently_employed_company_automatic: false} : {...branch, currently_employed_company_automatic: false})
    );
  }

  const handleOnSaveBranches = () => {
    if (companyBranches.filter(branch => branch.currently_employed_company_primary_location === true).length > 1) {
      setSnackBarMessage('Only one primary location is allowed');
      setShowSnackBar(true);
      return;
    }

    if (companyBranches.filter(branch => branch.currently_employed_company_primary_location === true).length === 0) {
      setSnackBarMessage('At least one location should be primary');
      setShowSnackBar(true);
      return;
    }

    axios.post(
      `/v1/admin/ria_contacts/${contactId}/update_company_branches/`,
      {
        company_branches: companyBranches,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { status } = response.data;
      if (status === 'success') {
        setSnackBarMessage('Branch updated successfully');
        setCompanyBranches(companyBranches.map((branch) => ({...branch, changed: false})))
      } else {
        setSnackBarMessage('Branch update failed');
      }
      setShowSnackBar(true);
    });
  }

  const handleCloseSnackBar = () => {
    setSnackBarMessage('');
    setShowSnackBar(false);
  }

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, tabNumber)}>
        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === tabNumber ? classes.tabActive : ''}`}>Company Info</Typography>
        {(statusBranches !== 'fetched' || statusCurrentCompanies !== 'fetched') ? <CircularProgress /> : ''}
        {tab === tabNumber ? <ExpandLess /> : <ExpandMore />}
      </div>
      <Collapse in={tab === tabNumber}>
        <div className={classes.contentSectionContent}>
          <div className={classes.formGroup}>
            <div className={classes.registrationContainer}>
              <Typography variant='h5' className={classes.innerSectionTitle} onClick={() => setCompanyBranchesAccordion(!companyBranchesAccordion)}>
                Company Branches
                <span className={classes.headerIconContainer}>{companyBranchesAccordion ? <Remove /> : <Add />}</span>
              </Typography>

              <Collapse in={companyBranchesAccordion} className={classes.innerSectionCollapse}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.inheritFontWeight}>CRD ID</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Branch City</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Branch Country</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Branch State</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Branch Street_1</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Branch Street_2</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Branch Postal</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Branch ID</TableCell>
                      <TableCell className={classes.inheritFontWeight}>ELA Begin Date</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Primary</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Automatic</TableCell>
                      <TableCell className={classes.inheritFontWeight}>HQ</TableCell>
                      <TableCell className={classes.inheritFontWeight}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <CompanyBranchesRow companyBranches={companyBranches} handleOnChangePrimaryLocation={handleOnChangePrimaryLocation}/>
                  </TableBody>
                </Table>
                { companyBranches.find(branch => branch.changed) && <Button color="primary" variant="contained" style={{marginBottom: '40px'}} onClick={handleOnSaveBranches}>Save Changes</Button>}
              </Collapse>
            </div>
            <Divider />

            <div className={classes.registrationContainer}>
              <Typography variant='h5' className={classes.innerSectionTitle} onClick={() => setCurrentlyEmployedAccordion(!currentlyEmployedAccordion)}>
                Currently Employed
                <span className={classes.headerIconContainer}>{currentlyEmployedAccordion ? <Remove /> : <Add />}</span>
              </Typography>

              <Collapse in={currentlyEmployedAccordion} className={classes.innerSectionCollapse}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.inheritFontWeight}>CRD ID</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Name</TableCell>
                      <TableCell className={classes.inheritFontWeight}>HQ City</TableCell>
                      <TableCell className={classes.inheritFontWeight}>HQ Country</TableCell>
                      <TableCell className={classes.inheritFontWeight}>State</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Street 1</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Street 2</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Postal</TableCell>
                      <TableCell className={classes.inheritFontWeight}>Employment Start Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <CurrentlyEmployedRow currentCompanies={currentCompanies}/>
                  </TableBody>
                </Table>
              </Collapse>
            </div>
          </div>
        </div>
      </Collapse>

      <CustomSnackbar
          open={showSnackBar}
          closeHandler={handleCloseSnackBar}
          message={snackBarMessage}
          options={{
            severity: 'error'
          }}
      />
    </div>
  )
}

export default CompanyInfo;